import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import {router} from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import Vuelidate from 'vuelidate'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import VCalendar from 'v-calendar'
import VueQrcodeReader from "vue-qrcode-reader";

// import 'v-calendar/lib/v-calendar.min.css'
import 'vue-search-select/dist/VueSearchSelect.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'vue-select/dist/vue-select.css';
import 'vue-search-select/dist/VueSearchSelect.css'

import { ModelSelect } from "vue-search-select";

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.use(Vuelidate)
Vue.use(VueNotifications, options)

Vue.component('ModelSelect', ModelSelect)

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  firstDayOfWeek: 2,
  datePickerShowDayPopover: false,
  locale: 'id-ID',
  masks: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['DD MMM YYYY'],
    dayPopover: 'D',
    data: ['YYYY-MM-DD']
  }
})

Vue.use(VueQrcodeReader);


new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
